export type ScrollData = {
  clientHeight: number;
  distanceFromBottom: number;
  distanceFromTop: number;
  maxScroll: number;
  scrollHeight: number;
  scrollOffset: number;
};

type ScrollHandlerProps = {
  onScroll: (scrollData: ScrollData) => void;
};

export const createScrollHandler =
  ({ onScroll }: ScrollHandlerProps) =>
  (event: React.UIEvent<HTMLDivElement>) => {
    const element = event.currentTarget;

    const scrollOffset = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    const maxScroll = scrollHeight - clientHeight;
    const distanceFromBottom = maxScroll - scrollOffset;
    const distanceFromTop = scrollOffset;

    onScroll({
      clientHeight,
      distanceFromBottom,
      distanceFromTop,
      maxScroll,
      scrollHeight,
      scrollOffset,
    });
  };
